/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-17 16:51:52
 *
 *******************************************************/
// @flow

import type { Action } from './store.type';

export const GET_PRODUCT_VISIBILITY_RULES_REQUEST = 'GET_PRODUCT_VISIBILITY_RULES_REQUEST';
type GET_PRODUCT_VISIBILITY_RULES_REQUEST_TYPE = 'GET_PRODUCT_VISIBILITY_RULES_REQUEST';

export const GET_PRODUCT_VISIBILITY_RULES_SUCCESS = 'GET_PRODUCT_VISIBILITY_RULES_SUCCESS';
type GET_PRODUCT_VISIBILITY_RULES_SUCCESS_TYPE = 'GET_PRODUCT_VISIBILITY_RULES_SUCCESS';

export const GET_PRODUCT_VISIBILITY_RULES_FAILURE = 'GET_PRODUCT_VISIBILITY_RULES_FAILURE';
type GET_PRODUCT_VISIBILITY_RULES_FAILURE_TYPE = 'GET_PRODUCT_VISIBILITY_RULES_FAILURE';

type ProductVisibilityRuleType = {};

type GetProductVisibilityRulesSuccess = {
  data: Array<ProductVisibilityRuleType>,
  total: number
};

type ProductVisibilityRuleFailure = {
  error: any
};

type GetProductVisibilityRulesRequestAction = Action<
  GET_PRODUCT_VISIBILITY_RULES_REQUEST_TYPE,
  null
>;

type GetProductVisibilityRulesSuccessAction = Action<
  GET_PRODUCT_VISIBILITY_RULES_SUCCESS_TYPE,
  GetProductVisibilityRulesSuccess
>;

type GetProductVisibilityRulesFailureAction = Action<
  GET_PRODUCT_VISIBILITY_RULES_FAILURE_TYPE,
  GetProductVisibilityRuleFailure
>;

// Update Product visibility rules
type UpdateProductVisibilityRulesSuccess = {
  data: ProductVisibilityRuleType
};

export const UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST = 'UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST';
type UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST_TYPE = 'UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST';

export const UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS = 'UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS';
type UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS_TYPE = 'UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS';

export const UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE = 'UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE';
type UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE_TYPE = 'UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE';

type UpdateProductVisibilityRulesRequestAction = Action<
  UPDATE_PRODUCT_VISIBILITY_RULES_REQUEST_TYPE,
  null
>;

type UpdateProductVisibilityRulesSuccessAction = Action<
  UPDATE_PRODUCT_VISIBILITY_RULES_SUCCESS_TYPE,
  UpdateProductVisibilityRulesSuccess
>;

type UpdateProductVisibilityRulesFailureAction = Action<
  UPDATE_PRODUCT_VISIBILITY_RULES_FAILURE_TYPE,
  ProductVisibilityRuleFailure
>;

// Action and State
export type ProductVisibilityAction =
  | GetProductVisibilityRulesRequestAction
  | GetProductVisibilityRulesSuccessAction
  | GetProductVisibilityRulesFailureAction
  | UpdateProductVisibilityRulesRequestAction
  | UpdateProductVisibilityRulesSuccessAction
  | UpdateProductVisibilityRulesFailureAction;

export type ProductVisibilityState = {
  loading: boolean,
  saving: boolean,

  success: boolean,
  error: null,
  productVisibilityRules: Array<ProductVisibilityRuleType>,
  total: number
};
